"use strict";

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _currencyFormatter = _interopRequireDefault(require("currency-formatter"));

var _useSiteDefaults = require("../../../src/hooks/use-site-defaults");

function CurrencyConverter(props) {
  var data = (0, _useSiteDefaults.useSiteDefaults)();
  var edges = data;
  var currencyFormat;
  var preText;
  var postText;
  edges.forEach(function (edge) {
    currencyFormat = edge.node.frontmatter.currencyFormat;
    preText = currencyFormat.preText;
    postText = currencyFormat.postText;
  });
  var mainCurrency = currencyFormat.currencies.filter(function (currency) {
    return currency.currency === props.currency;
  });
  var mainCurrencyPre;
  var mainCurrencyPost;
  var mainCurrencyThousand;
  var mainCurrencyDecimal;
  var mainCurrencyNumOfDecimals;
  var mainCurrencyConversion;
  mainCurrency.forEach(function (mainCurrency) {
    mainCurrencyPre = mainCurrency.preIndicator;
    mainCurrencyPost = mainCurrency.postIndicator;
    mainCurrencyThousand = mainCurrency.thousandSeparator;
    mainCurrencyDecimal = mainCurrency.decimalSeparator;
    mainCurrencyNumOfDecimals = mainCurrency.numOfDecimals;
    mainCurrencyConversion = mainCurrency.conversionRateFromUsd;
  });
  var mainAmount = props.amount;

  if (props.amount - Math.floor(mainAmount) === 0) {
    mainCurrencyNumOfDecimals = 0;
  }

  mainAmount = _currencyFormatter["default"].format(mainAmount, {
    decimal: mainCurrencyDecimal,
    thousand: mainCurrencyThousand,
    precision: mainCurrencyNumOfDecimals
  });
  var otherCurrencies = currencyFormat.currencies.filter(function (currency) {
    return currency.currency !== props.currency;
  });
  var output = mainCurrencyPre + mainAmount + mainCurrencyPost + " " + preText;
  var convert = null;
  var convertedCurrencies = null;
  otherCurrencies.forEach(function (currency) {
    if (props.currency === "usd") {
      convert = props.amount * currency.conversionRateFromUsd;

      if (props.amount - Math.floor(props.amount) === 0 && convert > 10) {
        convert = _currencyFormatter["default"].format(convert, {
          decimal: currency.decimalSeparator,
          thousand: currency.thousandSeparator,
          precision: 0
        });
      } else {
        convert = _currencyFormatter["default"].format(convert, {
          decimal: currency.decimalSeparator,
          thousand: currency.thousandSeparator,
          precision: currency.numOfDecimals
        });
      }
    } else if (props.currency === "cad") {
      convert = props.amount * (1 / mainCurrencyConversion) * currency.conversionRateFromUsd;

      if (props.amount - Math.floor(props.amount) === 0 && convert > 10) {
        convert = _currencyFormatter["default"].format(convert, {
          decimal: currency.decimalSeparator,
          thousand: currency.thousandSeparator,
          precision: 0
        });
      } else {
        convert = _currencyFormatter["default"].format(convert, {
          decimal: currency.decimalSeparator,
          thousand: currency.thousandSeparator,
          precision: currency.numOfDecimals
        });
      }
    } else {
      convert = props.amount * (1 / mainCurrencyConversion) * currency.conversionRateFromUsd;

      if (convert > 10) {
        convert = _currencyFormatter["default"].format(convert, {
          decimal: currency.decimalSeparator,
          thousand: currency.thousandSeparator,
          precision: 0
        });
      } else {
        convert = _currencyFormatter["default"].format(convert, {
          decimal: currency.decimalSeparator,
          thousand: currency.thousandSeparator,
          precision: currency.numOfDecimals
        });
      }
    }

    if (convertedCurrencies === null) {
      convertedCurrencies = currency.preIndicator + convert + currency.postIndicator + ", ";
    } else {
      convertedCurrencies = convertedCurrencies + currency.preIndicator + convert + currency.postIndicator + ", ";
    }
  });
  convertedCurrencies = convertedCurrencies.trim().slice(0, -1);
  return (
    /*#__PURE__*/
    _react["default"].createElement(_react["default"].Fragment, null, output, convertedCurrencies, postText)
  );
}

var _default = CurrencyConverter;
exports["default"] = _default;